import tinymce from "./tinymce";
import {Modal} from "bootstrap";
import naja from "naja";

export default function(html) {
	const form = html.querySelector('form#frm-profileManager-profileForm')
	if (form) {
		const ajaxStartCallback = (event) => {
			if (event.detail.request.method !== 'GET') {
				html.querySelector('#ajaxLoader')?.classList.remove('d-none')
			}

			html.querySelectorAll('.modal').forEach((el) => {
				if (!el.dataset.ajaxHideSkip) {
					Modal.getInstance(el)?.hide();
				}
			})
		}

		const snippetAfterUpdateCallback = () => {
			html.querySelector('#ajaxLoader')?.classList.add('d-none')
		}

		naja.removeEventListener('start', ajaxStartCallback)
		naja.addEventListener('start', ajaxStartCallback)

		naja.snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback)
		naja.snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback)

		const redirectHandler = (event) => {
			if (!event.detail.url.includes('editorMode=')) {
				event.detail.setHardRedirect(true)
			}
		}

		naja.redirectHandler.removeEventListener('redirect', redirectHandler)
		naja.redirectHandler.addEventListener('redirect', redirectHandler)


		form.querySelectorAll('textarea[rows="1"]').forEach((el) => {
			el.addEventListener('keydown', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault()
				}
			})
		})

		form.querySelectorAll('[data-tinymce]').forEach((el) => {
			el.addEventListener('focus', (e) => {
				e.currentTarget.previousElementSibling.classList.remove('visually-hidden');

				tinymce({
					selector: 'textarea#' + e.currentTarget.getAttribute('id') + '[data-tinymce]',
					height: 360,
					autofocus: true
				})

				window.tinymce.get(e.currentTarget.getAttribute('id'))?.show()
			})
		})

		form.querySelectorAll('.tinymce-helper').forEach((el) => {
			el.addEventListener('click', (e) => {
				const parent = e.currentTarget.parentElement
				const helper = parent.querySelector('.tinymce-helper')
				helper.classList.add('d-none')

				const input = parent.querySelector('[data-tinymce]')
				input.classList.remove('d-none')
				input.focus()

				const editor = window.tinymce.get(input.getAttribute('id'))
				editor.show()
				editor.focus()
			})
		})

		form.querySelectorAll('.upload-helper').forEach((el) => {
			const input = el.querySelector('input[type=file]')
			input.addEventListener('change', (e) => {
				const multiple = e.currentTarget.hasAttribute('multiple')
				let row = e.currentTarget.closest('.upload-helper').nextElementSibling

				for (const file of e.target.files) {
					if (file.type.startsWith("image/")) {
						const col = document.createElement("div")
						const remove = document.createElement("button")
						const img = document.createElement("img")

						col.classList.add('img-preview')
						col.classList.add('not-uploaded')
						if (multiple) {
							col.classList.add('multiple')
						}

						remove.setAttribute('type', 'button')
						remove.classList.add('remove')

						remove.innerHTML = '<i class="fas fa-times"></i>'
						remove.addEventListener('click', (e) => {
							row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
								el.remove()
							})

							input.value = null

							if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
								el.classList.remove('d-none')
								el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
							}
						})

						img.file = file
						img.classList.add('img-fluid')
						if (multiple) {
							img.setAttribute('style', 'max-height: 120px')
						}

						col.appendChild(remove)
						col.appendChild(img)
						row.appendChild(col)

						el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')

						const reader = new FileReader()
						reader.onload = () => {
							if (typeof  reader.result === 'string') {
								img.src = reader.result
							}
						}
						reader.readAsDataURL(file)

					} else {
						const col = document.createElement("div")
						const text = document.createElement("div")
						const remove = document.createElement("button")

						col.classList.add('file-preview')
						col.classList.add('not-uploaded')
						if (multiple) {
							col.classList.add('multiple')
						}

						remove.setAttribute('type', 'button')
						remove.classList.add('remove')

						remove.innerHTML = '<i class="fas fa-times"></i>'
						remove.addEventListener('click', (e) => {
							row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
								el.remove()
							})

							input.value = null

							if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
								el.classList.remove('d-none')
								el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
							}
						})

						text.classList.add('file')
						text.classList.add('text-nowrap')
						text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name

						col.appendChild(remove)
						col.appendChild(text)
						row.appendChild(col)

						el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')
					}
				}

				el.classList.add('d-none')
			})

			el.addEventListener('click', (e) => {
				const input = el.querySelector('input[type=file]')
				if (input) {
					input.click()
				}
			})
		})

		html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el) => {
			el.addEventListener('click', (e) => {
				const root = e.currentTarget.closest('.d-flex')
				const stack = root.nextElementSibling
				stack.value += e.currentTarget.dataset.id + ';'

				e.currentTarget.closest('.img-preview')?.remove()
				e.currentTarget.closest('.file-preview')?.remove()

				if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
					root.previousElementSibling.classList.remove('d-none')
					root.parentElement.querySelector('.upload-more')?.classList.add('d-none')
				}
			})
		})

		html.querySelectorAll('[data-bs-toggle=modal][data-url]').forEach((el) => {
			el.addEventListener('click', (e) => {
				const loader = document.querySelector('#contentPreviewLoader')
				loader.classList.remove('d-none')

				const iframe = document.querySelector('#contentPreviewModal iframe')
				iframe.classList.add('d-none')

				const url = e.currentTarget.getAttribute('data-url')
				if (url) {
					const callback = (e) => {
						loader.classList.add('d-none')
						e.currentTarget.classList.remove('d-none')
					}

					iframe.removeEventListener('load', callback)
					iframe.addEventListener('load', callback)

					iframe.setAttribute('src', url)

				} else {
					alert('URL not found.')
				}
			})
		})
	}
}
